import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Custom styles for the date picker - professional look
const customStyles = `
  /* Make the entire picker wider to accommodate both calendar and time */
  .react-datepicker-popper {
    min-width: 600px !important;
  }
  
  /* Position bottom-end pickers correctly */
  .react-datepicker-popper[data-placement="bottom-end"] {
    margin-top: 8px !important;
  }
  
  
  /* Ensure the main container has proper width and fixed height */
  .react-datepicker {
    display: flex !important;
    width: 100% !important;
    height: 21rem !important;
    max-height: 21rem !important;
    overflow: hidden !important;
  }
  
  /* Make calendar container take appropriate space with fixed height */
  .react-datepicker__month-container {
    flex: 1 !important;
    min-width: 280px !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  /* Ensure month container content is properly sized and visible */
  .react-datepicker__month-container .react-datepicker__month {
    margin: 0.5rem 0 !important;
    padding: 0 !important;
    display: block !important;
  }
  
  /* Make time container significantly wider and properly sized */
  .react-datepicker__time-container {
    width: 180px !important;
    min-width: 180px !important;
    flex-shrink: 0 !important;
    border-left: 1px solid #aeaeae !important;
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
  }
  
  .react-datepicker__time-container .react-datepicker__time {
    width: 100% !important;
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    width: 100% !important;
    flex: 1 !important;
    display: block !important;
    position: relative !important;
    overflow: hidden !important;
  }
  
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box .react-datepicker__time-list {
    height: 100% !important;
    max-height: 320px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
  
  /* Fix header navigation arrows - position them near month/year dropdowns */
  .react-datepicker__header {
    padding: 0.5rem 0.75rem !important;
    position: relative !important;
  }
  
  /* Hide the redundant month/year display since we have dropdowns */
  .react-datepicker__current-month {
    display: none !important;
  }
  
  /* Position navigation arrows near the month/year dropdown area */
  .react-datepicker__navigation {
    top: 1.5rem !important;
  }
  
  .react-datepicker__navigation--previous {
    left: 0.75rem !important;
  }
  
  .react-datepicker__navigation--next {
    right: auto !important;
    left: calc(50% + 60px) !important;
  }
  
  /* Make year and month dropdowns smaller and consistent */
  .react-datepicker__month-dropdown-container,
  .react-datepicker__year-dropdown-container {
    font-size: 0.75rem !important;
    margin: 0 0.25rem !important;
  }
  
  .react-datepicker__month-read-view,
  .react-datepicker__year-read-view {
    font-size: 0.75rem !important;
    padding: 0.25rem 0.5rem !important;
    border: 1px solid #d1d5db !important;
    border-radius: 0.375rem !important;
    background: white !important;
  }
  
  .react-datepicker__month-dropdown,
  .react-datepicker__year-dropdown {
    font-size: 0.75rem !important;
    border: 1px solid #d1d5db !important;
    border-radius: 0.375rem !important;
    background: white !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1) !important;
  }
  
  .react-datepicker__month-option,
  .react-datepicker__year-option {
    font-size: 0.75rem !important;
    padding: 0.375rem 0.5rem !important;
  }
  
  /* Consistent font sizes throughout */
  .react-datepicker__day-name,
  .react-datepicker__day {
    font-size: 0.875rem !important;
    width: 2rem !important;
    line-height: 2rem !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  /* Align day names with date columns - remove gaps */
  .react-datepicker__day-names {
    display: flex !important;
    justify-content: space-around !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .react-datepicker__day-name {
    flex: 1 !important;
    text-align: center !important;
    width: auto !important;
  }
  
  /* Ensure calendar weeks align with day names */
  .react-datepicker__week {
    display: flex !important;
    justify-content: space-around !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  
  .react-datepicker__day {
    flex: 1 !important;
    text-align: center !important;
    width: auto !important;
  }
  
  .react-datepicker__time-list {
    height: 100% !important;
    min-height: 280px !important;
    max-height: 320px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
  }
  
  /* Ensure time list container allows scrolling */
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
    overflow: hidden !important;
    position: relative !important;
  }
  
  /* Make sure time list is scrollable */
  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box .react-datepicker__time-list {
    position: relative !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
  }
  
  /* Hide days from adjacent months to prevent confusion */
  .react-datepicker__day--outside-month {
    visibility: hidden !important;
    pointer-events: none !important;
  }
  
  /* Ensure calendar weeks are visible and properly laid out */
  .react-datepicker__week {
    display: flex !important;
    justify-content: space-around !important;
    margin: 0 !important;
  }
  
  /* Ensure calendar shows all 6 weeks to display full month */
  .react-datepicker__month-container {
    min-height: 320px !important;
    overflow: visible !important;
  }
  
  /* Make sure all calendar days are visible - ensure 6 weeks are shown */
  .react-datepicker__month {
    min-height: 280px !important;
    padding-bottom: 0.5rem !important;
  }
  
  /* Ensure all weeks are displayed */
  .react-datepicker__month .react-datepicker__week {
    min-height: 2.5rem !important;
  }
  
  /* Ensure calendar body container has proper height */
  .react-datepicker__month-container .react-datepicker {
    height: 100% !important;
  }
  
  .react-datepicker__time-list-item {
    font-size: 0.875rem !important;
    height: 2rem !important;
    line-height: 2rem !important;
    padding: 0 0.75rem !important;
  }
  
  /* Dark mode support */
  .dark .react-datepicker__month-read-view,
  .dark .react-datepicker__year-read-view {
    background: #1f2937 !important;
    border-color: #374151 !important;
    color: #f3f4f6 !important;
  }
  
  .dark .react-datepicker__month-dropdown,
  .dark .react-datepicker__year-dropdown {
    background: #1f2937 !important;
    border-color: #374151 !important;
  }
  
  .dark .react-datepicker__month-option,
  .dark .react-datepicker__year-option {
    color: #f3f4f6 !important;
  }
  
  .dark .react-datepicker__month-option:hover,
  .dark .react-datepicker__year-option:hover {
    background-color: #374151 !important;
  }
  
  .dark .react-datepicker__time-container {
    border-left-color: #374151 !important;
  }
  
  .dark .react-datepicker__time-container .react-datepicker__time {
    background-color: #1f2937 !important;
  }
  
  .dark .react-datepicker__time-list-item {
    color: #f3f4f6 !important;
  }
  
  .dark .react-datepicker__time-list-item:hover {
    background-color: #374151 !important;
  }
  
  .dark .react-datepicker__time-list-item--selected {
    background-color: #3b82f6 !important;
    color: white !important;
  }
`;

// Inject styles into the document
const injectStyles = () => {
  if (typeof document !== 'undefined') {
    const styleId = 'react-datepicker-custom-styles';
    if (!document.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = customStyles;
      document.head.appendChild(style);
    }
  }
};

interface DateTimePickerProps {
  value?: string | null; // Format: "yyyy-mm-dd hh:mm:ss", ISO string, or null for unlimited
  onChange: (value: string | null) => void; // Returns ISO string or null
  placeholder?: string;
  disabled?: boolean;
  minDate?: Date | null; // Date object for minimum date, null to allow any date (including past), undefined defaults to today
  maxDate?: Date | null; // Date object for maximum date, null to allow any date (including future), undefined means no maximum
  showTimeSelect?: boolean;
  timeIntervals?: number;
  dateFormat?: string;
  className?: string;
  required?: boolean;
  returnFormat?: 'iso' | 'custom'; // 'iso' returns ISO string, 'custom' returns "yyyy-mm-dd hh:mm:ss"
  popperPlacement?: string; // Floating-ui placement (e.g., 'bottom-start', 'bottom-end', 'bottom')
  popperClassName?: string; // Custom class for the popper container
}

/**
 * Reusable DateTimePicker component that handles date and time selection
 * Returns values in "yyyy-mm-dd hh:mm:ss" format or null for unlimited
 */
const DateTimePicker: React.FC<DateTimePickerProps> = ({
  value,
  onChange,
  placeholder = 'Select date and time',
  disabled = false,
  minDate,
  maxDate,
  showTimeSelect = true,
  timeIntervals = 1, // Can be increased to reduce list size (e.g., 15 for 15-minute intervals)
  dateFormat = 'yyyy-MM-dd HH:mm:ss',
  className = '',
  required = false,
  returnFormat = 'custom', // Default to custom format for backward compatibility
  popperPlacement = 'bottom-end',
  popperClassName,
}) => {
  // Convert string value to Date object
  // Handle both ISO format (with T) and custom format (with space)
  const selectedDate = value && value !== 'Unlimited' 
    ? new Date(value.includes('T') ? value : value.replace(' ', 'T')) 
    : null;

  // Handle date change
  const handleDateChange = (date: Date | null) => {
    if (!date) {
      onChange(null);
      return;
    }

    if (returnFormat === 'iso') {
      // Return ISO string
      onChange(date.toISOString());
    } else {
      // Format to "yyyy-mm-dd hh:mm:ss"
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      onChange(formattedDate);
    }
  };

  // Default minDate to today if not explicitly provided
  // If minDate is explicitly null, don't set any minimum date restriction (allow past dates)
  // If minDate is a Date object, use that as the minimum
  const effectiveMinDate = minDate === undefined ? new Date() : minDate;

  // Inject custom styles on mount
  useEffect(() => {
    injectStyles();
  }, []);

  // Build props object conditionally
  const datePickerProps: any = {
    selected: selectedDate,
    onChange: handleDateChange,
    showTimeSelect: showTimeSelect,
    timeIntervals: timeIntervals,
    timeFormat: "HH:mm:ss",
    dateFormat: dateFormat,
    placeholderText: placeholder,
    disabled: disabled,
    required: required,
    showYearDropdown: true,
    scrollableYearDropdown: true,
    yearDropdownItemNumber: 100,
    showMonthDropdown: true,
    dropdownMode: "select",
    calendarStartDay: 1,
    fixedHeight: true,
    allowSameDay: true,
    className: `w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-governate-500 focus:border-transparent disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed ${className}`,
    wrapperClassName: "w-full",
    strictParsing: false,
  };

  // Only set minDate if it's not null (null means no restriction)
  if (minDate !== null) {
    datePickerProps.minDate = effectiveMinDate;
  }

  // Only set maxDate if it's not null (null means no restriction, undefined means no maximum)
  if (maxDate !== null && maxDate !== undefined) {
    datePickerProps.maxDate = maxDate;
  }

  // Add optional props
  if (popperPlacement) {
    datePickerProps.popperPlacement = popperPlacement;
  }
  if (popperClassName) {
    datePickerProps.popperClassName = popperClassName;
  }
  datePickerProps.popperProps = {
    strategy: 'fixed' as const,
  };

  return (
    <DatePicker
      {...datePickerProps}
    />
  );
};

export default DateTimePicker;

